import consentsData from './consents.json';

export interface ConsentItem {
  id: string;
  title: string;
  description: string;
  formattedDescription?: string;
  checkbox: string;
}

export type ConsentRecord = Record<string, ConsentItem>;

// Type assertion to ensure the JSON matches our interface
export const consents = consentsData as ConsentRecord;

// Stamped onto every consent record so we can tell which wording someone agreed to.
// Bump this whenever consents.json changes, or past records become unattributable.
export const CONSENTS_VERSION = '2026-09-21';

export const ConsentConfig = {
  download: { advisor: [consents.advisorDownloadPolicyIllustration.id], client: [] },
  start: { advisor: [], client: [consents.clientReceiveDocsDigitally.id] },
  submit: {
    advisor: [
      consents.advisorAuthToDiscloseHealthInfo.id,
      consents.advisorCertificationOfAccuracy.id,
      consents.advisorBestInterestDisclosure.id,
      consents.advisorESignatureAndRecordsConsent.id,
    ],
    client: [
      consents.clientAuthToDiscloseHealthInfo.id,
      consents.clientCertificationOfAccuracy.id,
      consents.clientBestInterestDisclosure.id,
      consents.clientESignatureAndRecordsConsent.id,
    ],
  },
};

export const CarescoutConsentConfig = {
  ...ConsentConfig,
  start: { advisor: [], client: [consents.clientReceiveDocsDigitallyForCarescout.id] },
};

/**
 * Everything a client consents to for quote and apply, in one go: receiving documents digitally
 * (CareScout words it differently) and each consent needed to submit the application.
 */
export function clientApplicationConsentIds(isCareScout: boolean): string[] {
  const config = isCareScout ? CarescoutConsentConfig : ConsentConfig;
  return [...config.start.client, ...config.submit.client];
}

export const hierarchyInvitationConsentIdByAccessMode: Record<ClientAccessMode, string> = {
  full: consents.advisorAcceptHierarchyInvitationWithClientAccess.id,
  none: consents.advisorAcceptHierarchyInvitationWithoutClientAccess.id,
  specific: consents.advisorAcceptHierarchyInvitationWithSpecificClientAccess.id,
};
